export default __webpack_public_path__ + "static/media/habano-5Open.e889c8f0.jpg";